import React, { useState, useEffect } from 'react';
import { Tab, TabBody, TabBar, TabBarItem, TabBarLabel, TabBarIcon } from 'react-weui';
import { history, useLocation } from 'umi';
import wx from 'wx';
import { getAreaCode } from '@/services/js_sdk';

import IconCourse from '@/assets/tab_course.png';
import IconCourseSelected from '@/assets/tab_course_select.png';
import IconProgram from '@/assets/tab_program.png';
import IconProgramSelected from '@/assets/tab_program_select.png';
import IconMe from '@/assets/tab_me.png';
import IconMeSelected from '@/assets/tab_me_select.png';


const Layout = (props) => {
  const { children } = props;
  const location = useLocation();
  const [homeActive, setHomeActive] = useState(false);
  const [programActive, setProgramActive] = useState(false);
  const [selfActive, setSelfActive] = useState(false);

  useEffect(() => {
    if (location.pathname === '/nav/home') {
      setHomeActive(true);
      setProgramActive(false);
      setSelfActive(false);
    }
    if (location.pathname === '/nav/program') {
      setHomeActive(false);
      setProgramActive(true);
      setSelfActive(false);
    }
    if (location.pathname === '/nav/myself') {
      setHomeActive(false);
      setProgramActive(false);
      setSelfActive(true);
    }
  }, [location]);


  return (
    <Tab style={{height: '100vh'}}>
      <TabBody>
        {children}
      </TabBody>
      <TabBar style={{display: 'none'}}>
        <TabBarItem
          active={homeActive}
          onClick={() => {
            history.push('/nav/home');
          } }
          icon={<img alt={""} src={homeActive ? IconCourseSelected : IconCourse}/>}
          label={"课堂"} />
        <TabBarItem
          active={programActive}
          onClick={() => {
            wx.getLocation({
              type: "wgs84",
              cancel: () => {
                history.push('/nav/program');
              },
              fail: () => {
                history.push('/nav/program');
              },
              success: (res) => {
                if (res.errMsg === "getLocation:ok") {
                  getAreaCode({
                    lat: res.latitude,
                    lng: res.longitude,
                  }).then(response => {
                    console.log(response);
                    if (response.code === 200) {
                      window.localStorage.setItem('areaCode', response.data.ad_info.adcode);
                      history.push('/nav/program?adCode=' + response.data.ad_info.adcode);
                    } else {
                      history.push('/nav/program');
                    }
                  }).catch(() => {
                    history.push('/nav/program');
                  })
                }
              }
            })

          }}
          icon={<img alt={""} src={programActive ? IconProgramSelected : IconProgram}/>}
          label={"栏目"} />

        <TabBarItem
          active={selfActive}
          onClick={() => {
            history.push('/nav/myself' )
          }}
          icon={<img alt={""} src={selfActive ? IconMeSelected : IconMe}/>}
          label={"我的"} />
      </TabBar>
    </Tab>
  );
}

export default Layout;
